<template>
    <ProjectPage/>
</template>

<script>
// @ is an alias to /src
import ProjectPage from '@/components/ProjectPage.vue'

export default {
  name: 'ProjectView',
  components: {
    ProjectPage
  }
}
</script>